/**
 * Of de hal wordt opgenomen voor de film van de zweefronde (`remotion/`,
 * docs/zweeffilm.md). De film rendert elk beeld offline, met de tijd die
 * daarvoor nodig is; wat de kiosk per beeld niet kan betalen, kan daar wel.
 * De opname zet dit aan vóór de hal gemonteerd wordt. De kiosk laat het uit.
 *
 * Alleen wat hier en in de opname zelf staat verschilt tussen film en hal;
 * de scène is dezelfde code, zodat de overname op het hoofdscherm klopt.
 */
export const OPNAME = {
  aan: false,
  /** Kwaliteit van de AO in de film (`Effecten.tsx`); op een pc zonder GPU lager. */
  ao: 'ultra' as 'ultra' | 'high' | 'medium',
  /**
   * Waar in het beeld de opname is, 0–1: het hoeveelste deelbeeld van de
   * zestien (`remotion/src/Zweefronde.tsx`). Het Linde-beeld gebruikt het om
   * tussen twee aanzichten van de draaitafel over te vloeien (`LindeBeeld.tsx`).
   */
  deel: 0.5,
  /** Een tweede, van `deel` onafhankelijke 0–1 per deelbeeld (`bovenaf` in `LindeBeeld.tsx`). */
  deel2: 0.5,
  /**
   * Van hoog boven het 3D-model in plaats van het beeld van Linde. Linde fotografeerde
   * zijn draaitafels van 8 tot 25° hoogte; van veel hoger leest het beeld als een bord.
   */
  bovenaf: true,
  /**
   * De opname zet de camera zelf, vóór de hal (de hallfilm, `remotion/src/hallfilm`):
   * dan laat de `CameraRig` hem met rust. Zo kiest ook het Linde-beeld zijn
   * aanzicht bij de camera van de film, niet bij die van de zweefroute.
   */
  eigenCamera: false,
}
